'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;
// import Helmet from 'react-helmet'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _HowItWorks = require('./HowItWorks.css');

var _HowItWorks2 = _interopRequireDefault(_HowItWorks);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HowItWorks = (_dec = (0, _reactCssModules2.default)(_HowItWorks2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(HowItWorks, _Component);

  function HowItWorks(props) {
    (0, _classCallCheck3.default)(this, HowItWorks);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HowItWorks.__proto__ || (0, _getPrototypeOf2.default)(HowItWorks)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(HowItWorks, [{
    key: 'render',
    value: function render() {
      // images
      var sriIcon = require('../../../static/images/sri.png');
      var ussifLogo = require('../../../static/images/ussif-icon.png');
      var iconEngage = require('../../../static/images/icn-engagement-shield.svg');
      var cleanChart = require('../../../static/images/clean-chart.png');
      var dirtyChart = require('../../../static/images/dirty-chart.png');
      var categoryTotals = require('../../../static/images/category-totals.png');
      var holdingsList = require('../../../static/images/holdings-list.png');

      var title = 'How it works: Methodology';

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title),
        _react2.default.createElement(
          'div',
          { styleName: 'works-component-wrap' },
          _react2.default.createElement(_components.Works, { hideTitle: true })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(
            'div',
            { styleName: 'how-it-works' },
            _react2.default.createElement(
              'div',
              { styleName: 'how-it-works-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                title
              ),
              _react2.default.createElement(_components.Changelog, null),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'Searching the fund database'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Deforestation Free Funds'
                  ),
                  ' sources financial data on equities and mutual funds from Morningstar. Our database contains information on thousands of U.S. open-end and exchange traded mutual funds, some of the most common funds held in 401(k)s, 403(b)s, and other retirement plans.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Search for mutual funds using name, ticker symbol, or asset manager. ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.routes.clean, title: 'Search funds | Deforestation Free Funds' },
                    'Use the search page'
                  ),
                  ' to filter funds by investing style, fund family, and more. When you find a fund you\'re looking for, click on it to see the full results.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Looking for your favorite fund and can\u2019t find it? We don\'t have everything in our database - we only screen mutual funds that own direct stock investments, and can only display up to 3,000.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'Company deforestation research'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'The 2020 Deforestation Free Funds list is comprised of 380 publicly listed companies, compiled from independent research as well as from existing resources within the civil society research and investor advocacy communities on forest-risk companies, including ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.fAndf, title: 'Forests & Finance', xstrong: true },
                    'Forests & Finance'
                  ),
                  ', ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.forest500, title: 'Forest500', xstrong: true },
                    'Forest500'
                  ),
                  ', ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.cdpForests, title: 'CDP Forests', xstrong: true },
                    'CDP Forests'
                  ),
                  ', ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.supplychange, title: 'Supply Change.org', xstrong: true },
                    'Supply Change.org'
                  ),
                  ' and ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.spott, title: 'ZSL SPOTT', xstrong: true },
                    'ZSL SPOTT'
                  ),
                  '. Every company on the Deforestation Free Funds list may be considered at risk for exposure to tropical deforestation, whether directly through production and trading (Commodity producers and traders); through supply chain links (Major consumer brands); or through financing of producers and traders (Forest-risk banks and lenders). Where a company is a parent or a subsidiary of a privately held company, only the publicly listed company is named.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'How the list was compiled'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Most companies on the list were sourced through existing resources within the civil society research and investor advocacy communities, including ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.fAndf, title: 'Forests & Finance', xstrong: true },
                    'Forests & Finance'
                  ),
                  ', ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.forest500, title: 'Forest500', xstrong: true },
                    'Forest500'
                  ),
                  ', ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.cdpForests, title: 'CDP Forests', xstrong: true },
                    'CDP Forests'
                  ),
                  ', ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.supplychange, title: 'Supply Change.org', xstrong: true },
                    'Supply Change.org'
                  ),
                  ' and ',
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.spott, title: 'ZSL SPOTT', xstrong: true },
                    'ZSL SPOTT'
                  ),
                  '. '
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Relative criteria:'
                  ),
                  ' a significant percentage of company revenues are engaged in that deforestation-risk business sector. An example is Equatorial Palm Oil, which has a significant percentage of company revenues engaged in palm oil production.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Absolute criteria:'
                  ),
                  ' the percentage of company revenues engaged in that deforestation-risk business sector is not significant, but due to the large size of the company, the total amount of company revenue engaged in that deforestation-risk business sector is significant. An example is Amazon.com, which is a major consumer brand engaged in all six commodity sectors analyzed (palm oil, paper/pulp, rubber, timber, cattle, and soy). While the percentage of Amazon\'s company revenues engaged in these sectors is not significant, the sheer size of Amazon\'s operations makes the total amount of revenue significant.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Policy criteria:'
                  ),
                  ' the company has no corporate policies to manage and mitigate risk in the deforestation-risk business sectors it\'s engaged in (i.e. does not have a No Deforestation policy, or has gaps in achieving full implementation of said policy).'
                ),
                _react2.default.createElement(_components.ScreenedCompanies, null)
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'We calculate the total amount of exposure'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'For each mutual fund in our database, we examine every holding and determine if it is a stock issued by one of the companies on our three deforestation-risk lists: agricultural commodity producers and traders, banks and lenders, and major consumer brands.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Mutual funds can have a varying number of holdings, from less than one hundred to several thousand. We calculate the total number of flagged holdings in the fund, and the total amount and percentage of the fund\u2019s assets that are invested in those companies.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'sidebar' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'sidebar-title' },
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nospace: true }),
                  '\xA0',
                  _react2.default.createElement(
                    'em',
                    null,
                    'Measuring long holdings only'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'sidebar-info' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'When calculating a fund\'s exposure to a screen list, we only consider the portfolio\'s long investments, ignoring any shorts or liabilities. The formula for holding weight is ',
                    _react2.default.createElement(
                      'em',
                      null,
                      'holding market value divided by the sum of the market value for all long holdings in the portfolio.'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'If a fund doesn\'t invest in any of the deforestation-risk companies we look for, that means it earns an A grade. You\'ll see a chart like this:'
                ),
                _react2.default.createElement(
                  _components.Link,
                  { to: cleanChart, title: 'Chart for A grade fund' },
                  _react2.default.createElement('img', {
                    src: cleanChart,
                    alt: 'Chart for A grade fund',
                    styleName: 'chart-img'
                  })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'However, if a fund does have stock investments in deforestation-risk companies, you\'ll see a chart like this, showing the overall exposure.'
                ),
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: dirtyChart,
                    title: 'Chart for fund with deforestation-risk investments'
                  },
                  _react2.default.createElement('img', {
                    src: dirtyChart,
                    alt: 'Chart for fund with deforestation-risk investments',
                    styleName: 'chart-img'
                  })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The breakdown of exposure is listed for each of the three deforestation-risk categories.'
                ),
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: categoryTotals,
                    title: 'Table of breakdown of fund holdings for different deforestation-risk categories'
                  },
                  _react2.default.createElement('img', {
                    src: categoryTotals,
                    alt: 'Table of breakdown of fund holdings for different deforestation-risk categories',
                    styleName: 'chart-img'
                  })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The list of holdings flagged for each different type of deforestation-risk is also displayed.'
                ),
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: holdingsList,
                    title: 'Table of breakdown of specific fund holdings for a deforestation-risk category'
                  },
                  _react2.default.createElement('img', {
                    src: holdingsList,
                    alt: 'Table of breakdown of specific fund holdings for a deforestation-risk category',
                    styleName: 'chart-img'
                  })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'We only look for direct stock holdings in deforestation-risk companies. That means that holdings that are not stocks, like cash holdings or bonds, are not rated. In the fund\'s investment profile, we show a ',
                  _react2.default.createElement(
                    'em',
                    null,
                    'Percent Rated'
                  ),
                  ' metric, equivalent to the percent of the fund that is invested in stocks. The higher a fund\u2019s Percent Rated value, the more holdings we were able to examine. A fund with a lower Percent Rated value may have hidden deforestation-related investments that our tool cannot account for, in the form of bond holdings or other asset types.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'Deforestation grade'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Based on whether a fund has direct stock investments in these companies, we assign one of six grades. Only funds that own stocks are scored - bond funds and other asset classes are excluded.'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'grade-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 1, large: true }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'grade-bullet-copy' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'No holdings flagged for our deforestation screens: Assigned a grade of A.'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'grade-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 2, large: true }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'grade-bullet-copy' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Fund is invested in deforestation-risk banks and lenders and/or major consumer brands, but no holdings flagged for our deforestation-risk agricultural commodity producer/trader screen: Assigned a grade of B.'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'grade-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 3, large: true }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'grade-bullet-copy' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Fund is invested in deforestation-risk agricultural commodity producer/traders, below the threshold of 0.5%: Assigned a grade of C.'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'grade-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 4, large: true }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'grade-bullet-copy' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Fund is invested in deforestation-risk agricultural commodity producer/traders, above the threshold of 0.5% and below 1.5%: Assigned a grade of D.'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'grade-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 5, large: true }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'grade-bullet-copy' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Fund is invested in deforestation-risk agricultural commodity producer/traders, above the threshold of 1.5%: Assigned a grade of F.'
                    )
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'These thresholds reflect the distribution of results across funds, placing an approximately equal number of funds from the analysis universe in the C, D, and F grade ranges.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'If a fund owns some of the companies we screen for, but has a proven track record of engaging the companies it owns by taking actions such as filing shareholder resolutions on deforestation or similar environmental issues, it earns a special acknowledgement as a \u201Cknown sustainability engager\u201D, instead of a letter grade.'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'grade-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 1.5, large: true }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'grade-bullet-copy' },
                    _react2.default.createElement(
                      'p',
                      null,
                      '\u201CKnown sustainability engager\u201D grade. Fund is offered by an asset manager that frequently engages companies it invests in to push for better behavior using the shareholder resolution process.'
                    )
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.routes.faq + '#8', title: 'More about how fund managers engage companies on deforestation' },
                    ' Read more about how fund managers engage companies on deforestation.'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'Funds with sustainability mandates'
              ),
              _react2.default.createElement('img', {
                styleName: 'sri',
                src: sriIcon,
                alt: 'Sustainability mandate'
              }),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'p',
                  null,
                  'If you see this symbol, it means that fund has a sustainability mandate.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Funds with sustainability mandates make investment decisions based on issues like environmental responsibility, human rights, or religious views. A sustainability-mandated fund may take a proactive stance by selectively investing in, for example, environmentally-friendly companies, or firms with good employee relations. They may also avoid investing in companies involved in promoting alcohol, tobacco, or gambling, or in the defense industry.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'Sustainability engagement'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'engage-shield' },
                  _react2.default.createElement(_components.Grade, { grade: 1.5, large: true })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'If you see this symbol, it means that fund is a known sustainability engager.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Some sustainability-mandated funds actively engage the companies they own. Indeed, efforts by sustainability-focused investors whose funds are found on this site have been crucial to driving positive change in the palm oil sector. A number of fund families are ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    'known sustainability engagers'
                  ),
                  ', and have taken actions such as filing ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.aysvote, title: 'Vote Your Shares | As You Sow' },
                    'shareholder resolutions'
                  ),
                  ' asking for policy changes. Those families deserve special acknowledgement - often, they are using their investments to make sure they have a voice at the table to call for real improvements in company behavior. We used ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.ceres, title: 'Ceres Shareholder Resolution Database' },
                    'data collected by Ceres'
                  ),
                  ' to identify fund families that have filed shareholder resolutions on deforestation, climate change, or other environmental issues. If a fund owns companies we screen for, but the family is a known filer of deforestation or environmental-related shareholder resolutions, it earns a special engagement score. ',
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: '#7', title: 'FAQs | Deforestation Free Funds' },
                    'Read more about our deforestation grades.'
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Are you a fund manager that has filed a deforestation-related shareholder resolution, or otherwise engage the companies in your portfolio on sustainability issues?'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.contact, title: 'Contact As You Sow', xstrong: true },
                    'Get in touch - we\u2019d love to hear from you.'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'The Forum for Sustainable and Responsible Investment'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-info' },
                _react2.default.createElement('img', {
                  styleName: 'ussif',
                  src: ussifLogo,
                  alt: 'Member of The Forum for Sustainable and Responsible Investment'
                }),
                _react2.default.createElement(
                  'p',
                  null,
                  'If you see this symbol, it means that fund is a member of US-SIF.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    _components.Link,
                    { xstrong: true, to: _config2.default.links.ussif, title: 'The Forum for Sustainable and Responsible Investment - US-SIF' },
                    'The Forum for Sustainable and Responsible Investment'
                  ),
                  ' (known as US-SIF) is a group advancing sustainable, responsible, and impact investing. Asset managers who are members of US-SIF often have policies to exclude or restrict investments in companies with environmental or social risk.'
                )
              )
            )
          )
        ),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(
          'div',
          { styleName: 'banner-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-inner' },
            _react2.default.createElement(_components.AboutBanner, null)
          )
        )
      );
    }
  }]);
  return HowItWorks;
}(_react.Component)) || _class);
exports.default = HowItWorks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/HowItWorks/HowItWorks.js
// module id = 1324
// module chunks = 0